import SpriteSymbol from "../../../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../config/webpack/loaders/svg-sprite/utils/sprite";
var symbol = new SpriteSymbol({
  "id": "icon__youtube",
  "use": "icon__youtube-usage",
  "viewBox": "0 0 22 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 16\" id=\"icon__youtube\"><path d=\"M11 0C.19 0 0 .908 0 8s.19 8 11 8 11-.908 11-8-.19-8-11-8zm3.525 8.347l-4.939 2.178c-.432.189-.786-.023-.786-.474V5.949c0-.45.354-.663.786-.474l4.94 2.178c.432.191.432.503 0 .694z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol